import styled from 'styled-components';
import { font } from '../../assets/common';

const Dropdown = styled.div`
  margin: 20px 0;
  font-family: ${font.inter};
  font-size: 12px;
  font-weight: 500;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  text-align: left;

  .ant-select {
    width: ${(props) => props.size?.width || '200px'};
    overflow: hidden;
  }

  .ant-select-selector {
    height: ${(props) => `${props.size?.height || '45px'} !important`};
    border-radius: 6px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: ${(props) => `${props.size?.height || '45px'} !important`};
  }
`;

export { Dropdown };
